export const messages = {
  en: {
    complaintDetail: {
      title: 'Complaint Details',
      orderId: 'Order ID',
      type: 'Type',
      room: 'Room',
      contact: 'Contact',
      phone: 'Phone',
      status: 'Status',
      createTime: 'Create Time',
      content: 'Content',
      workflow: 'Workflow',
      evaluation: 'Evaluation',
      fetchError: 'Failed to fetch complaint details'
    },
    complaintDetailEvent: {
      type: 'Type',
      operator: 'Operator',
      remark: 'Remark',
      time: 'Time',
      submit: 'Submit',
      process: 'Process',
      evaluate: 'Evaluate',
      reply: 'Reply',
      fetchError: 'Failed to fetch event list'
    },
    complaintDetailAppraise: {
      user: 'User Name',
      content: 'Evaluation Content',
      score: 'Evaluation Score',
      status: 'Evaluation Status',
      time: 'Evaluation Time',
      replier: 'Replier',
      replyContent: 'Reply Content',
      pending: 'Pending Reply',
      replied: 'Replied',
      fetchError: 'Failed to fetch evaluation list'
    },
        complaintDetailType: {
      name: 'Type Name',
      notifyWay: 'Notification Method',
      replyType: 'Reply Type',
      handler: 'Handler',
      createTime: 'Create Time',
      sms: 'SMS',
      wechat: 'WeChat',
      autoReply: 'Auto Reply',
      manualReply: 'Manual Reply',
      fetchError: 'Failed to fetch type list'
    }
  },
  zh: {
    complaintDetail: {
      title: '投诉详情',
      orderId: '订单编号',
      type: '类型',
      room: '房屋',
      contact: '联系人',
      phone: '联系电话',
      status: '状态',
      createTime: '创建时间',
      content: '投诉内容',
      workflow: '工单流转',
      evaluation: '工单评价',
      fetchError: '获取投诉详情失败'
    },
    complaintDetailEvent: {
      type: '类型',
      operator: '操作人',
      remark: '说明',
      time: '时间',
      submit: '提交',
      process: '投诉处理',
      evaluate: '评价',
      reply: '评价回复',
      fetchError: '获取事件列表失败'
    },
    complaintDetailAppraise: {
      user: '用户名称',
      content: '评价内容',
      score: '评价得分',
      status: '评价状态',
      time: '评价时间',
      replier: '回复人',
      replyContent: '回复内容',
      pending: '待回复',
      replied: '已回复',
      fetchError: '获取评价列表失败'
    },
     complaintDetailType: {
      name: '类型名称',
      notifyWay: '通知方式',
      replyType: '评价回复',
      handler: '处理人',
      createTime: '创建时间',
      sms: '短信',
      wechat: '微信',
      autoReply: '自动回复',
      manualReply: '人工回复',
      fetchError: '获取类型列表失败'
    }
  }
}